export default __webpack_public_path__ + "static/media/App-Store-1.dc50ce8d.svg";